import { clsx } from 'clsx';
import { isString } from 'lodash-es';
import { extendTailwindMerge, twMerge } from 'tailwind-merge';

const customTwMerge = extendTailwindMerge({
  classGroups: {
    fontSize: [
      {
        text: [
          '11',
          '12',
          '13',
          '14',
          '15',
          '16',
          '18',
          '20',
          '26',
          '28',
          '32',
          '60',
          '100',
        ],
      },
    ],
  },
});

export function cn(...inputs) {
  return customTwMerge(clsx(inputs));
}
